import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { ReportingContactService } from '@http/clients/reporting-app/reporting-contact.service';
import { ReportsService } from '@services/reports.service';
import { EditorComponentBase, GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-contact-editor',
    templateUrl: './reporting-contact-editor.component.html',
    styleUrls: ['./reporting-contact-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent]
})
export class ReportingContactEditorComponent extends EditorComponentBase<number[] | null> implements OnInit, OnDestroy {
    items: IBaseDto[];
    selectedItems?: IBaseDto[];
    subscription?: Subscription;

    constructor(
        private readonly reportingUserService: ReportingContactService,
        private readonly reportsService: ReportsService
    ) {
        super();
        this.items = [];
    }

    async ngOnInit(): Promise<void> {
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (ready && this.bindingProperty !== null && this.bindingProperty?.length) {
                this.selectedItems = await this.reportingUserService.getByIds(this.bindingProperty);
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    async onSelectedItemsChange(): Promise<void> {
        if (this.selectedItems) {
            this.bindingProperty = this.selectedItems.length ? this.selectedItems.map((item) => item.id) : null;
            this.valueChange.emit();
        }
    }

    async onEntityTextChange(text: string) {
        this.items = await this.reportingUserService.search(text);
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
